import React, { Component } from 'react';

import { YesNoDialog } from 'Components';

class DeleteDialog extends Component {
  render() {
    const { calendar, shown, onConfirm, onCancel } = this.props;

    if (!calendar) {
      return null;
    }

    return (
      <YesNoDialog
        showDialog={shown}
        title={`Delete Calendar - ${calendar.Description}`}
        question={`Are you sure you want delete this School Calendar?`}
        yesCallback={onConfirm}
        noCallback={onCancel}
      />
    );
  }
}

export { DeleteDialog };



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/DeleteDialog.js